export enum MeetingSchedulerStatus {
  PENDING = "pending",
  CANCELLED = "cancelled",
  SCHEDULED = "scheduled"
}
